import { Grid, Button, TextField, FormControl } from '@mui/material';
import GenericSelectInput from './UI/GenericSelectInput';
import { Add } from "@mui/icons-material";
import SourceType from '../../../Models/Locations/sourceType';
import GenericInput from './UI/GenericInput';

export default function MappedIds({
  formik,
  sourceTypes,
}: {
  formik: any;
  sourceTypes: SourceType[];
}) {
  const onAddNewSourceMapping = async () => {
    const newItems = [
      ...formik.values.externalSourceMappings,
      {
        mappedId: '',
        sourceTypeId: null,
        notes: null,
      },
    ];
    formik.setFieldValue('externalSourceMappings', newItems);
  };

  return (
    <>
      {formik?.values?.externalSourceMappings?.length > 0 &&
        formik?.values?.externalSourceMappings?.map((item: any, index: number) => {
          return (
            <Grid container key={index} alignItems={'center'} my={1}>
              <Grid item xs={4} px={2}>
                <GenericInput
                  name={`externalSourceMappings.${index}.mappedId`}
                  label="Mapped Id"
                  placeholder="Mapped Id"
                  maxLength={150}
                  inputMode="text"
                  value={item.mappedId}
                  onChange={(e: any) => {
                    formik.setFieldValue(
                      `externalSourceMappings.${index}.mappedId`,
                      e.target.value,
                    );
                  }}
                  errorMsg={
                    formik.touched.externalSourceMappings &&
                      formik.touched.externalSourceMappings[index] &&
                      formik.touched.externalSourceMappings[index]['mappedId'] &&
                      formik.errors.externalSourceMappings &&
                      formik.errors.externalSourceMappings[index] &&
                      formik.errors.externalSourceMappings[index]['mappedId']
                      ? formik.errors.externalSourceMappings[index]['mappedId']
                      : ''
                  }
                  hasError={
                    formik.touched.externalSourceMappings &&
                      formik.touched.externalSourceMappings[index] &&
                      formik.touched.externalSourceMappings[index]['mappedId'] &&
                      formik.errors.externalSourceMappings &&
                      formik.errors.externalSourceMappings[index] &&
                      formik.errors.externalSourceMappings[index]['mappedId']
                      ? true
                      : false
                  }
                  onBlur={() => {
                    formik.setFieldTouched(`externalSourceMappings.${index}.mappedId`, true);
                  }}
                />
              </Grid>

              <Grid item xs={4} px={2}>
                <GenericSelectInput
                  name={`externalSourceMappings.${index}.sourceTypeId`}
                  label="Type"
                  value={item.sourceTypeId}
                  onChange={(value: string) => {
                    formik.setFieldValue(`externalSourceMappings.${index}.sourceTypeId`, value);
                  }}
                  errorMsg={''}
                  hasError={false}
                  onBlur={() => {
                    formik.setFieldTouched(`externalSourceMappings[${index}].sourceTypeId`, true);
                  }}
                  options={sourceTypes} />
              </Grid><Grid item xs={4} px={2}>
                <FormControl fullWidth>
                  <TextField
                    name="notes"
                    label="Source Notes"
                    rows={4}
                    variant="outlined"
                    value={item.notes}
                    onChange={(e: any) => {
                      formik.setFieldValue(
                        `externalSourceMappings.${index}.notes`,
                        e.target.value
                      );
                    }}
                    helperText={formik.touched.externalSourceMappings &&
                      formik.touched.externalSourceMappings[index] &&
                      formik.touched.externalSourceMappings[index]['notes'] &&
                      formik.errors.externalSourceMappings &&
                      formik.errors.externalSourceMappings[index] &&
                      formik.errors.externalSourceMappings[index]['notes']
                      ? formik.errors.externalSourceMappings[index]['notes']
                      : ''}
                    error={formik.touched.externalSourceMappings &&
                      formik.touched.externalSourceMappings[index] &&
                      formik.touched.externalSourceMappings[index]['notes'] &&
                      formik.errors.externalSourceMappings &&
                      formik.errors.externalSourceMappings[index] &&
                      formik.errors.externalSourceMappings[index]['notes']
                      ? true
                      : false}
                    onBlur={() => {
                      formik.setFieldTouched(`externalSourceMappings.${index}.notes`, true);
                    }} />
                </FormControl>

              </Grid>

              <Grid item xs={3} px={1}>
                {formik.values.externalSourceMappings.length > 1 && (
                  <Button
                    type="button"
                    onClick={() => {
                      const newItems = [...formik.values.externalSourceMappings];
                      newItems.splice(index, 1);
                      formik.setFieldValue('externalSourceMappings', [...newItems]);
                    }}
                  >
                    Remove
                  </Button>
                )}

                {index === formik.values.externalSourceMappings.length - 1 && (
                    <Button
                      type="button"
                      onClick={onAddNewSourceMapping}
                      startIcon={<Add />}
                    >
                      Add Other Id
                    </Button>
                  )}
              </Grid>
            </Grid>
          )
        })
      }

    </>
  );
}
